<div class="attachment-single-select">
  <div class="right-section">
    <div class="button-group" *ngIf="!isDisabled && value && !value.deleted">
      <button nbButton
              status="basic"
              ghost
              [disabled]="!value || value.deleted"
              nbTooltip="Nach links drehen"
              nbTooltipStatus="basic"
              (click)="rotateSelection(-90)">
        <nb-icon icon="undo-outline" pack="eva"></nb-icon>
      </button>
      <button nbButton
              status="basic"
              ghost
              [disabled]="!value || value.deleted"
              nbTooltip="Nach rechts drehen"
              nbTooltipStatus="basic"
              (click)="rotateSelection(90)">
        <nb-icon class="flip-icon" icon="undo-outline" pack="eva"></nb-icon>
      </button>
      <button nbButton
              status="danger"
              ghost
              [disabled]="!value || value.deleted"
              nbTooltip="Löschen"
              nbTooltipStatus="danger"
              (click)="deleteFile()"> <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
      </button>
    </div>
  </div>
  <ng-container *ngIf="value && !value.deleted; else noAttachment">
    <div class="preview-wrapper">
      <wr-attachment-preview [attachment]="value"
                             [nbSpinner]="!!(loading$|async)"
                             nbSpinnerStatus="primary"
                             [isDisabled]="isDisabled"
                             (imageEditClick)="fileInput.click()">
      </wr-attachment-preview>
    </div>

    <input #fileInput
           hidden
           class="file-input"
           type="file"
           [accept]="getAcceptForFileType(type())"
           (change)="onFilesSelected($event)"/>
  </ng-container>

  <ng-template #noAttachment>
    <ng-container *ngIf="isDisabled; then disabled; else editing"></ng-container>

    <ng-template #disabled>
      <span class="text-hint" [ngSwitch]="type">
        <ng-container *ngSwitchCase="'IMAGE'">Kein Bild ausgewählt</ng-container>
        <ng-container *ngSwitchCase="'FILE'">Keine Datei ausgewählt</ng-container>
      </span>
    </ng-template>

    <ng-template #editing>
      <wr-attachment-drop-zone [nbSpinner]="!!(loading$|async)"
                               nbSpinnerStatus="primary"
                               (fileSelected)="upload($event)"
                               [type]="type()"
                               [multiple]="false">
      </wr-attachment-drop-zone>
    </ng-template>
  </ng-template>
</div>
